module.exports = __webpack_public_path__ + "static/media/11NEPAD6.c6d4be66.jpg";